import type { TabKey } from './navigation';

export type ArrivalReason = 'tab' | 'back' | 'push';

export function tabTarget(
  tab: { key: TabKey; path: string },
  activeTab: TabKey,
  remembered: ReadonlyMap<TabKey, string>,
): string {
  if (tab.key === activeTab) return tab.path;
  return remembered.get(tab.key) ?? tab.path;
}

export function arrivalScroll(
  href: string,
  reason: ArrivalReason,
  saved: ReadonlyMap<string, number>,
): number {
  if (reason === 'push') return 0;
  return saved.get(href) ?? 0;
}

export const maxRemembered = 200;

export function remember<K, V>(map: Map<K, V>, key: K, value: V): void {
  map.delete(key);
  map.set(key, value);
  while (map.size > maxRemembered) {
    const oldest = map.keys().next().value as K;
    map.delete(oldest);
  }
}
